import type { RestStoreDebt } from "@KassaroAB/shared/types/storeDebt";

export const pairTitle = (
  storeDebt: RestStoreDebt | undefined,
  fallback: string,
) => (storeDebt ? `${storeDebt.storeName1} / ${storeDebt.storeName2}` : fallback);

export const getDebtorName = (
  storeDebt: RestStoreDebt,
  settledLabel: string,
) => {
  if (storeDebt.balanceForStore1.amount < 0) {
    return storeDebt.storeName1;
  }
  if (storeDebt.balanceForStore1.amount > 0) {
    return storeDebt.storeName2;
  }
  return settledLabel;
};

export const getStoreDebtOwed = (storeDebt: RestStoreDebt) => {
  const outstanding = Math.abs(storeDebt.balanceForStore1.amount);
  const isStore1Debtor = storeDebt.balanceForStore1.amount < 0;
  return {
    outstanding,
    debtorName: isStore1Debtor ? storeDebt.storeName1 : storeDebt.storeName2,
    creditorName: isStore1Debtor ? storeDebt.storeName2 : storeDebt.storeName1,
  };
};
